export const GET_ALL_NOTIFICATIONS_REQUEST = 'GET_ALL_NOTIFICATIONS_REQUEST';
export const GET_ALL_NOTIFICATIONS_SUCCESS = 'GET_ALL_NOTIFICATIONS_SUCCESS';
export const GET_ALL_NOTIFICATIONS_FAIL = 'GET_ALL_NOTIFICATIONS_FAIL';
export const GET_ALL_NOTIFICATIONS_RESET = 'GET_ALL_NOTIFICATIONS_RESET';

export const SEND_NOTIFICATION_REQUEST = 'SEND_NOTIFICATION_REQUEST';
export const SEND_NOTIFICATION_SUCCESS = 'SEND_NOTIFICATION_SUCCESS';
export const SEND_NOTIFICATION_FAIL = 'SEND_NOTIFICATION_FAIL';
export const SEND_NOTIFICATION_RESET = 'SEND_NOTIFICATION_RESET';
